import React from 'react'
import moment from 'moment'

import { Grid, Cell } from 'components/layout/grid'
import ArrowLink from 'components/ui/ArrowLink/ArrowLink'

import s from './MonthTitle.scss'


const MonthTitle = ({ month, year, isPrevArrowVisible, gutter, goPrevMonth, goNextMonth }) => {
  const monthName = moment(month, 'MM').format('MMMM')

  return (
    <Grid className={s.title} columns={3} gutter={gutter}>
      <Cell className={s.leftArrow} size={1}>
        {
          isPrevArrowVisible && (
            <ArrowLink direction="left" onClick={goPrevMonth} />
          )
        }
      </Cell>
      <Cell className={s.monthName} size={1}>{monthName} {year}</Cell>
      <Cell className={s.rightArrow} size={1}>
        <ArrowLink direction="right" onClick={goNextMonth} />
      </Cell>
    </Grid>
  )
}



export default MonthTitle
